// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2719":"4925bfc9","4572":"bfcee973"}[chunkId] + ".chunk.css";
};